import { Injectable, signal } from '@angular/core';
export interface ConfirmRequest {
  readonly title: string;
  readonly message: string;
  readonly confirmLabel: string;
  readonly danger: boolean;
}
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private readonly requestState = signal<ConfirmRequest | null>(null);
  private resolver: ((value: boolean) => void) | null = null;
  readonly request = this.requestState.asReadonly();
  open(options: Partial<ConfirmRequest> & Pick<ConfirmRequest, 'message'>): Promise<boolean> {
    if (this.resolver)
      this.resolver(false);
    this.requestState.set({
      title: options.title ?? 'Подтверждение',
      message: options.message,
      confirmLabel: options.confirmLabel ?? 'Подтвердить',
      danger: options.danger ?? false,
    });
    return new Promise(resolve => { this.resolver = resolve; });
  }
  resolve(value: boolean): void {
    this.requestState.set(null);
    this.resolver?.(value);
    this.resolver = null;
  }
}
